import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalDevicesExceeded.scss';
import { Grid, cls } from '../../packages/components';
import PropTypes from 'prop-types';
import Asset from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';

export const ERROR_CODE_DEVICES_EXCEEDED = 'PLY_CSS_00001';

const MAIN_CLASSNAME = 'aaf-main-modal-devices-exceeded';

const ModalDevicesExceeded = ({onRetry = ()=> {}, onReject = ()=>{}, handleClose = ()=>{}, errorCode }) => {
    const asset = Asset.get('fallenChannel_access_icon_alert_exit','/images/alert_icon.png');
    const title = Translator.get('playingLive_alert_limit_Reproductions_title', 'Límite de reproducciones');
    const content = Translator.get(errorCode ||  ERROR_CODE_DEVICES_EXCEEDED,'Se ha alcanzado el límite de reproducciones simultáneas con esta cuenta. Para continuar deja de reproducir en alguno de los dispositivos activos.');
    const buttons = [
        {
            content: Translator.get('playingLive_alert_limit_Reproductions_button_retry','REINTENTAR'),
            extraClass: `${MAIN_CLASSNAME}-btn`,
            props:{
                onClick:(e) => {
                    onRetry();
                },
                variant: 'dark'
            }
        },
        {
            content: Translator.get('playingLive_alert_limit_Reproductions_button_cancel','CANCELAR'),
            extraClass: `${MAIN_CLASSNAME}-btn`,
            props: {
                onClick: (e) => handleClose(e, onReject),
                variant: 'dark'
            }
        }
    ];
    const modalProps = {
        className: MAIN_CLASSNAME,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        showLogo: false,
        asset,
        title,
        content,
        buttons,
    };
    return (
        <ModalWrapper {...modalProps}/>
    );
}

ModalDevicesExceeded.defaultProps = {
    onRetry: ()=>{},
    handleClose: ()=>{},
}

ModalDevicesExceeded.propTypes = {
    onRetry: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
}

export default withOnClose(ModalDevicesExceeded);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDevicesExceeded.jsx